import {
	CustomizedCadenceBulkAccountLoader,
	PollingDriftClientAccountSubscriber,
} from '@drift-labs/sdk';
import { PublicKey } from '@solana/web3.js';
import { useCallback } from 'react';
import invariant from 'tiny-invariant';
import useDriftClient from 'src/hooks/useDriftClient';

export const useUpdateAccountLoaderCadence = () => {
	const driftClient = useDriftClient();

	const updateAccountLoaderCadence = useCallback(
		(publicKey: PublicKey, ms: number) => {
			if (!driftClient) return;

			const accountSubscriber = driftClient.accountSubscriber;

			if (!accountSubscriber) return;

			if (accountSubscriber instanceof PollingDriftClientAccountSubscriber) {
				if (
					accountSubscriber.accountLoader instanceof
					CustomizedCadenceBulkAccountLoader
				) {
					accountSubscriber.accountLoader.setCustomPollingFrequency(
						publicKey,
						ms
					);
				} else {
					invariant(
						false,
						"can't call updateAccountLoaderCadence if Account subscriber is not a CustomizedCadenceBulkAccountLoader"
					);
				}
			}
		},
		[driftClient]
	);

	return { updateAccountLoaderCadence };
};
